import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import { ChakraProvider } from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useEffect, useState } from 'react';
import OfflinePage from 'components/OfflinePage';
import './i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/auth/sign-in" replace />;
};

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOnline) return <OfflinePage />;

  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={currentTheme}>
        <Routes>
          {/* Auth routes accessible without a token */}
          <Route path="auth/*" element={<AuthLayout />} />

          {/* Protect /admin routes */}
          <Route
            path="admin/*"
            element={
              <ProtectedRoute>
                <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
              </ProtectedRoute>
            }
          />

          {/* Redirect root path to /admin or /auth/sign-in depending on token */}
          <Route
            path="/"
            element={
              localStorage.getItem('token') ? (
                <Navigate to="/admin" replace />
              ) : (
                <Navigate to="/auth/sign-in" replace />
              )
            }
          />
        </Routes>
      </ChakraProvider>
    </QueryClientProvider>
  );
}
